export const AdminUsers = ["BRACCHI", "LUCA", "C9999", "C9000", "C009999"];
